import { render, staticRenderFns } from "./bindModel.vue?vue&type=template&id=9dbed8dc&scoped=true&"
import script from "./bindModel.vue?vue&type=script&lang=js&"
export * from "./bindModel.vue?vue&type=script&lang=js&"
import style0 from "./bindModel.vue?vue&type=style&index=0&id=9dbed8dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbed8dc",
  null
  
)

export default component.exports